import { ChangeDetectionStrategy, Component, OnInit, signal, viewChild, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatIcon } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { ClickStopPropagationDirective } from '@src/suite/common/directives/stop-propagation';
import { OPTION_BLANK } from '@src/suite/common/enums/constants';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { selectRundownTemplates } from '@src/suite/common/store/records/records.selectors';
import { initializeRecord } from '@src/suite/common/utils/record-utils';
import { LiveApiActions } from '@src/suite/live/store/actions/live.actions';

import { BaseMainCtaComponent } from '../base-main-cta.component';

@Component({
    selector: 'st-live-main-cta',
    imports: [ClickStopPropagationDirective, MatButtonModule, MatButtonToggleModule, MatIcon, MatListModule, MatMenuModule],
    templateUrl: './live-main-cta.component.html',
    styleUrl: './live-main-cta.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-live-main-cta',
    },
})
export class LiveMainCtaComponent extends BaseMainCtaComponent implements OnInit {
    readonly optionBlank = OPTION_BLANK;

    readonly menuTrigger = viewChild<MatMenuTrigger>(MatMenuTrigger);

    readonly rundownEditable = signal<boolean>(true);

    readonly rundownTemplates = this.store.selectSignal(selectRundownTemplates);

    ngOnInit() {
        this.rundownEditable.set(this.globalTablesService.securityPrivileges[this.nomWebServicesJson?.HelloResults?.HomeProgram]?.rundown?.write);
    }

    onRundownTemplateMenuOpened() {
        this.store.dispatch(LiveApiActions.loadRundownTemplates());
    }

    public async selectRundownTemplateOrNew(template?: StorytellingRundownRecord) {
        if (!template?.isDeleted) {
            this.menuTrigger().closeMenu();
            this.store.dispatch(
                LiveApiActions.openRundownPropertiesDialog({
                    record: {
                        ...(template || initializeRecord(ObjectTypes.RUNDOWN)),
                        isNewRecord: true,
                        SourceGUID: template?.Guid,
                        Title: template && template?.Guid !== OPTION_BLANK ? template?.Title : '',
                    },
                    popUpTitle: this.languageSettings.PSTRundownCreateNewRundown,
                })
            );
        }
    }
}
